<template>
  <v-card
    :flat="!$vuetify.breakpoint.smAndUp"
  >
    <v-card-title :class="!$vuetify.breakpoint.smAndUp ? 'pa-0' : ''">
      {{ `${job.company.name}` }} <br>
      {{ `${job.name} ${job.number ? '#' : ''}${job.number}` }}
    </v-card-title>
    <v-card-text v-if="job.notes">
      <h4> Notes from the Production Manager </h4>
      {{ job.notes }}
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    job: {
      type: Object,
      default: () => {},
    },
    artLink: {
      type: Boolean,
    },
  },
};
</script>

<style>

</style>
